export default __webpack_public_path__ + "static/media/night-sky.51b096ab.png";